// extracted by mini-css-extract-plugin
export default {"item":"item-Dg4A","text":"text-hFl6","noteWrap":"noteWrap-YKGG","note":"note-q1nE","created":"created-JMGD","footer":"footer-N45X","buttons":"buttons-gRcy"};